import helper from "../utils/helper"

const mascaraParametrizacao = {
    horas: helper.decimalToTime
}

export default mascaraParametrizacao